import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=6e753fe8&scoped=true&"
var script = {}
import style0 from "./IconClose.vue?vue&type=style&index=0&id=6e753fe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e753fe8",
  null
  
)

export default component.exports